module.exports = __webpack_public_path__ + "media/audio50.bb248488.mp3";